export default __webpack_public_path__ + "static/media/utas-logo-small.8a7ef26a.svg";